// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchFaultRefTag {
constructor({
        id = null,
        emArchFaultId = '',
        emArchFaultFeatureTagId = ''}
= {}) {
    this.id = id;
    this.emArchFaultId = emArchFaultId;
    this.emArchFaultFeatureTagId = emArchFaultFeatureTagId;
}
}

function newEntity() {
return new EmArchFaultRefTag();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emArchFaultName',
        label: 'label.em.archive.emArchFaultRefTag.grid.emArchFaultName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchFaultFeatureTagName',
        label: 'label.em.archive.emArchFaultRefTag.grid.emArchFaultFeatureTagName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    emArchBasicDataCodeFilter : "",
    emArchBasicDataNameFilter : "",
    emArchFaultIdFilter : "",
    emArchFaultNameFilter : "",
    emArchFaultFeatureTagIdFilter : "",
    emArchFaultFeatureTagNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchBasicDataNameFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchBasicDataName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchFaultIdFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchFaultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFault'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchFaultNameFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchFaultName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchFaultFeatureTagIdFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchFaultFeatureTagId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultFeatureTag'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchFaultFeatureTagNameFilter',
        label: 'label.em.archive.emArchFaultRefTag.filter.emArchFaultFeatureTagName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'emArchFaultId',
        label: 'label.em.archive.emArchFaultRefTag.entity.emArchFaultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchFault'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchFaultFeatureTagId',
        label: 'label.em.archive.emArchFaultRefTag.entity.emArchFaultFeatureTagId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchFaultFeatureTag'
            ,correspondingField: 'id'
                }
        }
]

export {EmArchFaultRefTag, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
